export default {
    beforeMount: function(el, binding) {
        el.clickOutsideEvent = function(event) {
            // Check that click was outside the el and its children
            if (!(el == event.target || el.contains(event.target))) {
                // if it did, call method provided in attribute value
                const vm = binding.instance;
                binding.value.call(vm, event);
            }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
    },
    beforeUnmount: function(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
    }
};
